import { CoachElementTokenProvider } from '@efdigital/ll-addon-coaching/components/third-party/cronofy/coach-element-token-provider';
import { CronofyAvailabilityRules } from '@efdigital/ll-addon-coaching/components/third-party/cronofy/elements/availability-rules';
import { CronofyCalendarSync } from '@efdigital/ll-addon-coaching/components/third-party/cronofy/elements/calendar-sync';
import config from '@efdigital/ll-xceed-v2/config/environment';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

const cronofyConfig = config['ll-cronofy'];

interface AvailabilitySignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Availability"}}

  <CoachElementTokenProvider as |cronofyContext|>
    {{#if cronofyContext.accountStatus.hasCronofyAccount}}
      <div class="container my-3">
        <h3 class="gud-eyebrow">Availability</h3>
        <p class="lead">
          You are connected to your calendar(s). You can manage your
          availability and let coachees book sessions with you.
        </p>
        <CronofyAvailabilityRules @cronofyContext={{cronofyContext}} />
      </div>

      <hr />
    {{/if}}
    <div class="container my-4">
      <h3 class="gud-eyebrow">Calendar syncing</h3>

      {{#if cronofyContext.accountStatus.hasCronofyAccount}}
        <p class="lead">
          Your calendar(s) are synced with Xceed.
        </p>
      {{else}}
        <p class="lead">
          In order to manage your availability and let coachees book sessions
          with you, please connect your calendar to Xceed.
        </p>
      {{/if}}
      <ul class="mb-4">
        <li>This allows us to view and synchronize your availability for
          scheduling.</li>
        <li>We will not access your calendar(s) without your permission, and
          cannot see any details other than your availability.</li>
        <li>When a coach books a session, we will create a new event in your
          calendar for the session.</li>
      </ul>
      <div class="card border shadow-sm rounded-4">
        <div class="card-body p-4 p-lg-5">
          <CronofyCalendarSync
            @cronofyContext={{cronofyContext}}
            @cronofyConfig={{cronofyConfig}}
          />
        </div>
      </div>
    </div>
  </CoachElementTokenProvider>
</template> satisfies TOC<AvailabilitySignature>;
